export const ticketsFolder =
  'https://daymade-website-assets.s3.amazonaws.com/2026/tickets';
